export default { name: '@auth0/auth0-angular', version: '2.2.3' };
